import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { LlevelManger } from "../api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
export var LlevelService = /*#__PURE__*/function (_BaseResource) {
  _inherits(LlevelService, _BaseResource);
  var _super = _createSuper(LlevelService);
  function LlevelService() {
    _classCallCheck(this, LlevelService);
    return _super.apply(this, arguments);
  }
  _createClass(LlevelService, [{
    key: "pageList",
    value: function pageList(params) {
      return this.requester.get(LlevelManger.pageList, {
        params
      });
    }
  }, {
    key: "getMemberDetail",
    value: function getMemberDetail(params) {
      return this.requester.get(LlevelManger.getMemberDetail, {
        params
      });
    }
  }, {
    key: "type",
    value: function type() {
      return this.requester.get(LlevelManger.gameType);
    }
  }, {
    key: "betRecord",
    value: function betRecord(params) {
      return this.requester.get(LlevelManger.betRecord, {
        params
      });
    }
  }, {
    key: "rPageList",
    value: function rPageList(params) {
      return this.requester.get(LlevelManger.rPageList, {
        params
      });
    }
  }, {
    key: "getBonusRcds",
    value: function getBonusRcds(params) {
      return this.requester.get(LlevelManger.BonusRcds, {
        params
      });
    }
  }, {
    key: "report",
    value: function report(params) {
      return this.requester.get(LlevelManger.agentReport, {
        params
      });
    }
    // 新增溢出申请
  }, {
    key: "addSpill",
    value: function addSpill(params) {
      return this.requester.get(LlevelManger.addSpillApply, {
        params
      });
    }
    // 溢出申请列表
  }, {
    key: "spillList",
    value: function spillList(params) {
      return this.requester.get(LlevelManger.spillApplyList, {
        params
      });
    }
    // 备注保存
  }, {
    key: "editRemark",
    value: function editRemark(form) {
      return this.requester.post(LlevelManger.editRemark, form);
    }
    // 查询会员游戏余额
  }, {
    key: "gameBalance",
    value: function gameBalance(params) {
      return this.requester.post(LlevelManger.gameBalance, params);
    }
    // 获取代理会员奖励列表
  }, {
    key: "getDivideInviteReward",
    value: function getDivideInviteReward(params) {
      return this.requester.get(LlevelManger.inviteRewardList, {
        params
      });
    }
    // 邀请统计
  }, {
    key: "findInviteReward",
    value: function findInviteReward() {
      return this.requester.get(LlevelManger.findInviteReward);
    }
    // 奖金
  }, {
    key: "findBonusRecord",
    value: function findBonusRecord(params) {
      return this.requester.get(LlevelManger.findBonusRecord, {
        params
      });
    }
  }]);
  return LlevelService;
}(BaseResource);